import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M20.25 3v15a.75.75 0 0 1-.75.75H6.75a1.5 1.5 0 0 0-1.5 1.5H18a.75.75 0 1 1 0 1.5H4.5a.75.75 0 0 1-.75-.75V5.25a3 3 0 0 1 3-3H19.5a.75.75 0 0 1 .75.75"
    }, null, -1)
  ])))
}
export default { render: render }